import type { TextMeasure } from './markupBounds';
import { textFont } from './markupStyle';

// Rough bold-sans glyph width per font size, for a browser without a 2D context.
const FALLBACK_EM_RATIO = 0.6;

let measuringContext: CanvasRenderingContext2D | null = null;

function context(): CanvasRenderingContext2D | null {
    if (!measuringContext) measuringContext = document.createElement('canvas').getContext('2d');
    return measuringContext;
}

// Uses the same font string as the renderer, so hit areas match the painted label.
export const measureLabel: TextMeasure = (text, fontSize) => {
    const ctx = context();
    if (!ctx) return text.length * fontSize * FALLBACK_EM_RATIO;
    ctx.font = textFont(fontSize);
    return ctx.measureText(text).width;
};
